import React from 'react';
import styled from 'styled-components';
import {COLORS, Button, Typography, LoadingIndicator} from '@fupa/fupa-uikit';
import {ContentAdDesktop, FlexContainer} from 'app/styles/content';
import {useLocation} from 'react-router';
import {Helmet} from 'react-helmet-async';
import {TITLE_POSTFIX} from 'app/seo/seo.constants';

const SubTitle = styled(Typography)`
  display: block;
  margin: 1rem 0;
`;

const Text = styled(Typography)`
  &&& {
    color: ${COLORS.darkGrey};
  }
`;

const LinkContainer = styled(FlexContainer)`
  justify-content: center;
  padding-top: 2rem;
  margin: 1rem;
  a {
    text-decoration: none;
  }
`;

const CustomContent = styled(ContentAdDesktop)`
  box-sizing: border-box;
  justify-content: center;
  padding-left: 1rem;
  padding-right: 1rem;
  padding-bottom: 2rem;
`;

const AuthProtectedPage = ({loading, top = '4.5rem'}) => {
  const location = useLocation();
  const loginUrl = `/auth/login?redirectUrl=${encodeURIComponent(location.pathname)}`;
  const meta = [
    {
      name: 'description',
      content: 'Melde dich an, um diese Funktionen und Inhalte zu nutzen.',
    },
    {
      name: 'robots',
      content: 'noindex, follow',
    },
  ];

  if (loading) {
    return (
      <CustomContent noTabs top={top}>
        <LoadingIndicator message='Deine persönlichen Inhalte werden geladen...' />
      </CustomContent>
    );
  }

  return (
    <CustomContent noTabs top={top}>
      <Helmet title={`Fehlende Berechtigung${TITLE_POSTFIX}`} meta={meta} />
      <SubTitle variant='headline2' component='span'>
        Du kannst diese Inhalte leider nicht anonym sehen ⚽🤷🤷‍♂️
      </SubTitle>
      <Text variant='subheading'>Melde dich an, um diese Funktionen und Inhalte zu nutzen.</Text>
      <LinkContainer>
        <Button label='Jetzt Anmelden' onClick={() => (window.location = loginUrl)} />
      </LinkContainer>
    </CustomContent>
  );
};

export default AuthProtectedPage;
